// Libs
import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import * as Yup from 'yup';

// Own Libs
import * as ui from '@digital/ui';

//Api

//Files
import { UploadMultipleTable, Visibility, UploadFile, UploadMultipleTableTmp } from '@app/components';

//Utils
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { IArquivo, IArquivoActions } from '@app/types/core.types';
import { Icon } from '@digital/ui';

interface IModalInclusaoMultAnexoProps {
  onSubmit: (values: any) => Promise<boolean> | Promise<void>;
  buttonIcon?: React.ComponentProps<typeof ui.Icon>['name'];
  buttonTooltip?: string;
  buttonLabel?: string;
  buttonType?: "default" | "link" | "ghost" | "primary" | "dashed" | "danger" | undefined;

  modalTitle?: string;

  content?: string;
  styleContent?: any;
  showJustificativa?: boolean;
  isJustificativaInput?: boolean;
  labelJustificativa?: string;
  placeholderJustificativa?: string;
  rowJustificativa?: number;
  showUploadArquivos?: boolean;
  showButtonSave?: boolean;
  textButtonSave?: string;
  actions?: React.ReactNode[];
  isMultAnexo?: boolean;
  showDataOnTable?: boolean;
  onGetArquivos?: () => Promise<IArquivo[]>;
  arquivoActions?: IArquivoActions;
  visible?: boolean;
  hasDatePicker?: boolean;
  labelDatePicker?: string;
  hasSetFileName?: boolean;
  labelBotaoUpload?: string;
  disabled?: boolean;
  disabledFields?: boolean;
  initialValues?: IInitialValuesForm;
  requiredAnexos?: boolean;
  onlyModal?: boolean;
  onlyModalOpenController?: boolean;
  onChangeOpen?: (value: boolean) => void;

  modalConfirmType?: "info" | "success" | "error" | "warning" | "confirm";
  modalConfirmTitle?: React.ReactNode;
  modalConfirmContent?: React.ReactNode;
  modalConfirmOnOk?: (...args: any[]) => any;
  modalConfirmOnCancel?: (...args: any[]) => any;
  // modalConfirmIcon?: React.ReactNode;
  modalConfirmIcon?: React.ComponentProps<typeof ui.Icon>['name'];
  modalConfirmOkText?: string;
  modalConfirmCancelText?: string;

}

interface IInitialValuesForm {
  justificativa?: string;
  arquivos?: any[];
  date?: string;
}

export const ModalInclusaoMultAnexo = ({
  onSubmit,
  buttonIcon,
  buttonTooltip,
  buttonLabel,
  buttonType = 'primary',

  modalTitle,

  content,
  styleContent,
  actions,
  showJustificativa = true,
  placeholderJustificativa = 'Justificativa',
  labelJustificativa = 'Justificativa',
  rowJustificativa = 4,
  isJustificativaInput = false,
  showUploadArquivos = true,
  showButtonSave = true,
  textButtonSave,
  isMultAnexo = true,
  showDataOnTable,
  onGetArquivos,
  arquivoActions,
  visible,
  hasDatePicker = false,
  labelDatePicker = 'Data',
  hasSetFileName = false,
  labelBotaoUpload,
  disabled = false,
  disabledFields = false,
  initialValues,
  requiredAnexos = true,
  onlyModal = false,
  onlyModalOpenController = false,
  onChangeOpen,

  modalConfirmType = "info",
  modalConfirmTitle,
  modalConfirmContent,
  modalConfirmOnOk,
  modalConfirmOnCancel,
  modalConfirmIcon,
  modalConfirmOkText,
  modalConfirmCancelText,

}: IModalInclusaoMultAnexoProps) => {

  const [exibirModal, setExibirModal] = useState(false);
  const [validationSchemaState, setvalidationSchemaState] = useState<any>();
  const [actionsState, setActionsState] = useState<React.ReactNode[]>([]);

  useEffect(() => {
    if (onlyModal) {
      setExibirModal(onlyModalOpenController);
    }
  }, [onlyModalOpenController]);

  useEffect(() => {

    let validationSchemaTmp = {};

    if (hasDatePicker) {
      validationSchemaTmp = {
        ...validationSchemaTmp,
        date: Yup.string().required('A data deve ser informada'),
      };
    }

    if (showJustificativa) {
      validationSchemaTmp = {
        ...validationSchemaTmp,
        justificativa: Yup.string()
          .required(`O campo ${labelJustificativa} é obrigatório.`)
          .max(2000, `O campo ${labelJustificativa} deve ter no máximo 2000 caracteres.`),
      };
    }

    if (showUploadArquivos && requiredAnexos) {
      if (isMultAnexo) {
        validationSchemaTmp = {
          ...validationSchemaTmp,
          arquivos: Yup.array()
            .min(1, 'É necessário anexar no mínimo um arquivo.')
        };
      } else {
        validationSchemaTmp = {
          ...validationSchemaTmp,
          arquivo: Yup.mixed().required('É necessário anexar um arquivo.')
        };
      }
    }
    setvalidationSchemaState(Yup.object().shape(validationSchemaTmp));

    let actionsTmp = [
      <Visibility
        visible={disabled != true}
      >
        <ui.Button type='link' title='Fechar' onClick={() => setExibirModal(false)} />

        <Visibility visible={showButtonSave}>
          {isObjNotEmpty(textButtonSave) ? (
            <ui.FormSubmitButton noIcon type="primary" disabled={disabled}>
              {textButtonSave}
            </ui.FormSubmitButton>
          ) : (
            <ui.FormSubmitButton noIcon type="primary" disabled={disabled}>
              <ui.FormatText id="ui.commons.save" uppercase />
            </ui.FormSubmitButton>
          )}
        </Visibility>

      </Visibility>,
    ];

    setActionsState([...actionsTmp, ...actions || []]);

    onChangeOpen && onChangeOpen(exibirModal);
  }, [exibirModal]);

  const onCancel = () => {
    setExibirModal(false);
  };

  return (
    <Visibility
      visible={visible}
    >
      <Visibility visible={!onlyModal}>
        <Tooltip title={buttonTooltip || buttonLabel}>
          <ui.Button
            key="sgc-button-ModalInclusaoMultAnexo"
            id="sgc-button-ModalInclusaoMultAnexo"
            icon={buttonIcon}
            size="large"
            onClick={() => { setExibirModal(true); }}
            disabled={disabled}
            type={buttonType}
          >
            {buttonLabel}
          </ui.Button>
        </Tooltip>
      </Visibility>

      <Visibility
        visible={exibirModal}
      >
        <Modal
          title={modalTitle || buttonTooltip || buttonLabel}
          visible={exibirModal}
          onCancel={onCancel}
          footer={null}
          width="780px">
          <ui.MasterDetailForm
            key="sgc-form-ModalInclusaoMultAnexo"
            onSubmit={(values) => {
              let onS: any = values;
              onS.onCancel = onCancel;
              onSubmit(values)
                .then(value => {
                  if (value && value == true) {
                    onCancel();

                    if (isObjNotEmpty(modalConfirmTitle)) {

                      if (modalConfirmType == "confirm") {
                        Modal.confirm({
                          title: <>{modalConfirmTitle}</>,
                          content: <>{modalConfirmContent}</>,
                          okText: modalConfirmOkText,
                          cancelText: modalConfirmCancelText,
                          onOk: () => modalConfirmOnOk && modalConfirmOnOk([values]),
                          onCancel: () => modalConfirmOnCancel && modalConfirmOnCancel([values]),
                          icon: modalConfirmIcon && <Icon name={modalConfirmIcon} />
                        });
                      }

                      if (modalConfirmType == "error") {
                        Modal.error({
                          title: <>{modalConfirmTitle}</>,
                          content: <>{modalConfirmContent}</>,
                          okText: modalConfirmOkText,
                          cancelText: modalConfirmCancelText,
                          onOk: () => modalConfirmOnOk && modalConfirmOnOk([values]),
                          onCancel: () => modalConfirmOnCancel && modalConfirmOnCancel([values]),
                          icon: modalConfirmIcon && <Icon name={modalConfirmIcon} />
                        });
                      }

                      if (modalConfirmType == "warning") {
                        Modal.warning({
                          title: <>{modalConfirmTitle}</>,
                          content: <>{modalConfirmContent}</>,
                          okText: modalConfirmOkText,
                          cancelText: modalConfirmCancelText,
                          onOk: () => modalConfirmOnOk && modalConfirmOnOk([values]),
                          onCancel: () => modalConfirmOnCancel && modalConfirmOnCancel([values]),
                          icon: modalConfirmIcon && <Icon name={modalConfirmIcon} />
                        });
                      }
                    }

                  }
                });
            }}
            validationSchema={validationSchemaState}
            actions={actionsState}
            initialValues={initialValues
              ? initialValues
              : {
                justificativa: '',
                arquivos: [],
                date: '',
              }}
          >
            <Visibility
              visible={isObjNotEmpty(content)}
            >
              <ui.Row>
                <p style={styleContent}>
                  {content}
                </p>
              </ui.Row>
            </Visibility>

            <Visibility
              visible={hasDatePicker}
            >
              <ui.FormDatePicker
                format="DD/MM/YYYY"
                label={labelDatePicker}
                name="date"
                span={4}
                disabled={disabled || disabledFields}
              />
            </Visibility>

            <Visibility
              visible={showJustificativa && !isJustificativaInput}
              isFragment={false}
            >
              <ui.FormTextArea
                name="justificativa"
                label={labelJustificativa}
                placeholder={placeholderJustificativa}
                span={12}
                rows={rowJustificativa}
                disabled={disabled || disabledFields}
              />
            </Visibility>

            <Visibility
              visible={showJustificativa && isJustificativaInput}
              isFragment={false}
            >
              <ui.FormInput
                name="justificativa"
                label={labelJustificativa}
                placeholder={placeholderJustificativa}
                span={12}
                disabled={disabled || disabledFields}
              />
            </Visibility>

            <UploadMultipleTable
              visible={showUploadArquivos && isMultAnexo && onGetArquivos === undefined}
              idDoComponente={'sgc-upload-multi-ModalInclusaoMultAnexo'}
              name="arquivos"
              type="primary"
              showData={showDataOnTable}
              // onGetArquivos={onGetArquivos}
              // arquivoActions={arquivoActions}
              // hasSetFileName={hasSetFileName}
              disabled={disabled || disabledFields}
            />

            <UploadMultipleTableTmp
              visible={showUploadArquivos && (isMultAnexo == true) && onGetArquivos !== undefined}
              idDoComponente={'sgc-upload-multi-ModalInclusaoMultAnexo'}
              name="arquivos"
              type="primary"
              tablePagination={false}
              onGetArquivos={async () => onGetArquivos ? onGetArquivos() : []}
              disabled={disabled || disabledFields}
            />

            <Visibility
              visible={showUploadArquivos && (isMultAnexo == false)}
            >
              <ui.Row>
                <ui.Col span={7}>
                  <br></br>
                  <UploadFile
                    idDoComponente={'sgc-upload-single-ModalInclusaoMultAnexo'}
                    nameFormData="arquivo"
                    label={labelBotaoUpload}
                    type="primary"
                    hasFile={false}
                    disabled={disabled || disabledFields}
                    span={7}
                  />
                </ui.Col>
              </ui.Row>
            </Visibility>
          </ui.MasterDetailForm>
        </Modal>
      </Visibility>
    </Visibility>
  );
};
